import CtrlDesignacaoPage from './pages/CtrlDesignacaoPage.vue'

const routes = [
  {
    path: 'ctrl-designacao',
    name: 'ctrl-designacao',
    component: CtrlDesignacaoPage
  }
];

export default routes;
